import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';

import * as types from './types';
import getToken from '../../auth/getToken';
import getAccessToken from '../../auth/getAccessToken';
import getRefreshToken from '../../auth/getRefreshToken';
import { setItem } from '../../services/localStorageService';
import { LOCAL_STORAGE_KEYS } from '../../consts/constants';
import { AuthState } from '../../types';

type AuthAction = { type?: string; payload?: AuthState };

const initialState: AuthState = { 
  token: getToken() || null,
  accessToken: getAccessToken() || null,
  refreshToken: getRefreshToken() || null,
};

const authReducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case types.SET_AUTH:
      if (action?.payload?.token) {
        setItem(LOCAL_STORAGE_KEYS.AUTH_KEY, action.payload.token);
      }
      if (action?.payload?.accessToken) {
        setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, action.payload.accessToken);
      }
      if (action?.payload?.refreshToken) {
        setItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN, action.payload.refreshToken);
      }
      return {
        ...state,
        ...action.payload,
      };

    case types.CLEAR_AUTH:
      return { token: null, accessToken: null, refreshToken: null };
    default:
      return initialState;
  }
};

type AuthContextType = [AuthState | null, Dispatch<AuthAction>];
export const AuthContext = createContext<AuthContextType>([
  initialState,
  () => initialState,
]);

const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [authState, authDispatch] = useReducer(authReducer, initialState);

  return (
    <AuthContext.Provider value={[authState, authDispatch]}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
